<template>
  <div>
    <transition name="ani-slide-in">
      <keep-alive>
        <project-documentation-list-component></project-documentation-list-component>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import ProjectDocumentationListComponent
  from "../components/modules/ProjectDocumentation/ProjectDocumentationComponent";

export default {
  name: "ProjectDocumentation",
  components: {ProjectDocumentationListComponent}
}
</script>

<style scoped>

</style>